import React, {createRef, useEffect, useState} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';
import MasterclassItem from "./masterclass_item";


export default function MasterclassNextMenu({hasSuscription}) {
    const [menuActive, setMenuActive] = useState('next')
    const [items, setItems] = useState([])
    const [next, setNext] = useState([])
    const [old, setOld] = useState([])

    useEffect(() => {
        fetch('/ajax/masterclass/fetch-next')
            .then(r => r.json())
            .then(r => {
                setNext(r)
                setItems(r)
            })

        fetch('/ajax/masterclass/fetch-old')
            .then(r => r.json())
            .then(r => setOld(r))

    }, [])


    useEffect(() => {
        const listener = (event) => {
            const menuitem = event.detail
            setMenuActive(menuitem)
        }

        document.addEventListener('masterclass_menu_tabs', listener)

        return () => {
            document.removeEventListener('masterclass_menu_tabs', listener)
        }

    }, []);

    useEffect(() => {
        const listener = (event) => {
            const query = event.detail

            if(query.length > 0) {
                setItems(items => {

                    return items.filter(item => {
                        const search = `${item.name.toLowerCase()} ${item.description.toLowerCase()}`
                        return search.indexOf(query) > -1
                    })
                })
            } else {
                resetContent()
            }

        }

        document.addEventListener('masterclass_search_query', listener)

        return () => {
            document.removeEventListener('masterclass_search_query', listener)
        }
    }, [menuActive])

    function resetContent() {
        if(menuActive === 'next') setItems(next)
        if(menuActive === 'old') setItems(old)
        if(menuActive === 'bought') setItems([])
    }

    useEffect(() => {
        resetContent()
    }, [menuActive])

    let itemsSorted = items.map(a => {
        const date = new Date();

        const parts = a.starts_at.split(' ')
        const partsDate = parts[0].split('/')

        date.setFullYear(partsDate[2], partsDate[1], partsDate[0])

        return {
            ...a,
            timeSS: date.getTime()
        }
    })

    if (menuActive !== 'next') {
        itemsSorted.sort((a , b) => { return b.timeSS - a.timeSS })
    } else  {
        itemsSorted.sort((a , b) => { return b.timeSS + a.timeSS })
    }

    return (
        <Container>
            {itemsSorted.map(item => <MasterclassItem
                isDone={item.is_done}
                hasSuscription={hasSuscription}
                isFree={item.is_free == 1}
                slug={item.slug}
                key={`masterclass_item_${item.slug}`}
                startsDay={item.start_day_label}
                startsMonth={item.start_day_month}
                starsHour={item.start_day_time}
                title={item.name}
                price={item.price}
                description={item.description}
                teacher={item.teacher}
                hasAccess={item.is_registered}
            /> )}
        </Container>
    )
}


const Container = styled.div`
    padding: 8px;
    padding-top: 24px;
    padding-bottom: 80px;
    height: calc(100vh - 280px);
    overflow-y: scroll;
`

if (document.getElementsByTagName('masterclass-next-menu')) {
    const elms = document.getElementsByTagName('masterclass-next-menu')

    for(let elm of elms) {
        const hasSuscription = elm.attributes['has-suscription'].value == '1'
        ReactDOM.render(<MasterclassNextMenu
            hasSuscription={hasSuscription}
        />, elm);
    }
}
